<template>
  <div>
    <navbarBox />
    <addinvitecomponents />
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import addinvitecomponents from "@/components/addinvitecomponents.vue";
export default {
  components: { addinvitecomponents, navbarBox },
};
</script>
